import { ReactElement } from 'react';
import { LiteracyScreeningGradesModel } from '../../../types/LiteracyScreeningGradesModel';
import { LITERACY_SCREENING_END_OF_YEAR_SESSION } from '../../../types/LiteracyScreeningModel';
import LiteracyScreeningSessionPanel, {
  LiteracyScreeningSessionEditState,
} from './LiteracyScreeningSessionPanel';

interface LiteracyScreeningEndOfYearPanelProps {
  grades: LiteracyScreeningGradesModel[];
  schoolYear: string;
  disabled?: boolean;
  resetKey?: number;
  onEditStateChange?: (state: LiteracyScreeningSessionEditState) => void;
}

const LiteracyScreeningEndOfYearPanel = ({
  grades,
  schoolYear,
  disabled = false,
  resetKey,
  onEditStateChange,
}: LiteracyScreeningEndOfYearPanelProps): ReactElement => (
  <LiteracyScreeningSessionPanel
    heading="End of Year Screening"
    session={LITERACY_SCREENING_END_OF_YEAR_SESSION}
    grades={grades}
    schoolYear={schoolYear}
    disabled={disabled}
    resetKey={resetKey}
    onEditStateChange={onEditStateChange}
  />
);

export default LiteracyScreeningEndOfYearPanel;
